import { SET_SCHEDULE } from './index'

export const requestSetSchedule = (payload) => ({
  type: SET_SCHEDULE.REQUEST,
  payload,
})